import { FC } from "react";
import Layout from "components/Layout";
import CrudLayout from "components/CrudLayout";
import { TabList, Tabs, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import HouseTable from "components/HouseTable";
import HouseTypeTable from "components/HouseTypeTable";

const Houses: FC = () => {
  const path = "/houses";

  return (
    <Layout isPrivate>
      <CrudLayout breadcrumb={[{ title: "Rumah", link: path }]}>
        <Tabs>
          <TabList>
            <Tab>Rumah</Tab>
            <Tab>Tipe rumah</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <HouseTable />
            </TabPanel>
            <TabPanel>
              <HouseTypeTable />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </CrudLayout>
    </Layout>
  );
};

export default Houses;
